import { useQuery } from '@tanstack/react-query';
import { NotesTranscriptionRequests } from 'src/requests/notes-transcription';

export const useTranscriptionQuery = ({
  transcriptionId,
  noteId,
}: { transcriptionId: string; noteId: string }) => {
  const queryKey = ['transcription', noteId, transcriptionId];

  const {
    data: transcription,
    isFetching,
    refetch,
  } = useQuery({
    enabled: !!transcriptionId,
    queryKey,
    queryFn: () =>
      NotesTranscriptionRequests.getTranscriptionById(transcriptionId),
    refetchOnWindowFocus: false,
  });

  return {
    transcription,
    isFetching,
    refetch,
  };
};
